import { ApiInstance } from 'api/api-instance';
import {
  GET_VEHICLE_DOCUMENTS_URL,
  DOWNLOAD_DOCUMENTS_URL,
  DELETE_VEHICLE_DOCUMENT_URL,
  GetDocumentRequest,
  VehicleDocumentsResponse,
  PdfDocument,
  UploadDocumentsRequest,
  UploadDocumentsResponse,
  GET_UPLOAD_DOCUMENTS_KEY,
} from 'api/document';

import { BaseResponse } from 'api/api.types';
import { transformVehicleDocumentsInputFromServer } from 'api/document/document.adapter';
import { getFromLocalStorage } from 'global/utils/storage';
import { AUTH_TOKEN } from 'config/constant';

export class DocumentApi extends ApiInstance {
  public async getVehicleDocuments(request: GetDocumentRequest): Promise<BaseResponse<VehicleDocumentsResponse>> {
    return this.execute<VehicleDocumentsResponse>(this.http.post(GET_VEHICLE_DOCUMENTS_URL, { ...request })).then(
      (response: BaseResponse<any>) => {
        if (!response.hasError()) {
          return new BaseResponse<VehicleDocumentsResponse>({
            ...transformVehicleDocumentsInputFromServer(response.data),
          });
        }

        return response;
      },
    );
  }

  // eslint-disable-next-line class-methods-use-this
  public downloadDocuments(documents: PdfDocument[], parentId: string): void {
    const token = getFromLocalStorage(AUTH_TOKEN);
    const data = documents?.map(doc => doc.id).join(',');
    window.open(`${DOWNLOAD_DOCUMENTS_URL}?ticket=${token}&data=${data}&parent=${parentId}`, '_blank');
  }

  public deleteVehicleDocument(id: string): Promise<void> {
    return this.execute(this.http.delete(DELETE_VEHICLE_DOCUMENT_URL, { data: { unique_id: id } })) as any;
  }

  public uploadDocuments(request: UploadDocumentsRequest): Promise<BaseResponse<UploadDocumentsResponse>> {
    return Promise.all(
      request.documents.map(doc => {
        const formData = new FormData();
        formData.append('document', doc.file);
        formData.append('doc_type', doc.option.value);
        formData.append('unique_id', request.unique_id);

        return this.execute(
          this.http
            .post(GET_UPLOAD_DOCUMENTS_KEY, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .catch(e => ({ ...e, data: { ...e.data, documentsFailure: doc.option.label, success: false } })),
        );
      }),
    ).then(responses => {
      const failure = responses.some((response: any) => !response.data.success);
      return new BaseResponse({
        documentsFailure: responses.map((response: any) => ({ message: response.data?.documentsFailure || '' })),
        result: responses.map((response: any) => ({ message: response.data?.message || '' })),
        success: !failure,
      });
    }) as any;
  }
}
